/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Platforms_TitleInputs */

const en_pricing_platforms_title = /** @type {(inputs: Pricing_Platforms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen on the go on any device you own`)
};

const es_pricing_platforms_title = /** @type {(inputs: Pricing_Platforms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha donde vayas en cualquiera de tus dispositivos`)
};

/**
* | output |
* | --- |
* | "Listen on the go on any device you own" |
*
* @param {Pricing_Platforms_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_platforms_title = /** @type {((inputs?: Pricing_Platforms_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Platforms_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_platforms_title(inputs)
	return en_pricing_platforms_title(inputs)
});